///<reference path='es2015.collection.d.ts' />
///<reference path='fileformat.d.ts' />

import 'core-js/stable';

import { CrosswordController } from './controllers';
import { CrosswordRecording, CrosswordRecordingEvent,
         CrosswordState, CrosswordModel } from './models';

interface TranslationTable {
  [key: string]: string;
}

interface API {
  clear: () => void;
  getProgress: () => CrosswordState;
  highlightErrors: (duration?: number) => void;

  record: (id: string) => void;
  getRecording: (id: string) => CrosswordRecording|null;
  setRecording: (id: string, recording: CrosswordRecordingEvent[]) => void;

  // Provide letters to be entered into the given squares. The argument
  // `spacing` is a number specifying the time to wait before entering each
  // letter. If 0, all letters are entered simultanuously.
  fillSquares: (squares: HTMLElement[], letters: string[], spacing?: number) => void;

  // Set HTMLElements that shall, when clicked, keep the crossword selected
  // and active. Examples of protected elements would be the solverbar and
  // the clue listing when solving regular crosswords.
  setProtectedElements: (elements: HTMLElement[]) => void;
}

export const TRANSLATION_TABLE: TranslationTable = {
  'Across': 'Across',
  'Down': 'Down',
  'Load failed': 'Load failed',
};

export class App {
  public onLoad: (api: API) => void;
  public onError: (message: string, exception: any) => void;

  constructor (translations: TranslationTable) {
    for (let key in translations) {
      if (translations.hasOwnProperty(key)) {
        TRANSLATION_TABLE[key] = translations[key];
      }
    }
  }

  public init(id: number, el: HTMLElement, buffer: WordcrossFile.File, state: string): void {
    let model: CrosswordModel;
    let controller: CrosswordController;

    model = new CrosswordModel(id);

    try {
      model.load(buffer);
      controller = new CrosswordController(el, model);
      try {
        controller.render();
        controller.loadCrosswordState(state);
      } catch (exn) { throw exn; }
    } catch (exn) {
      if (this.onError) {
        this.onError(TRANSLATION_TABLE['Load failed'], {
          'name': exn.name,
          'message': exn.message
        });
      } else {
        throw Error('Error: No error handler found.');
      }
      return;
    }

    if (this.onLoad) {
      this.onLoad({
        'clear': () => controller.clear(),
        'record': (id: string) => controller.record(id),
        'getProgress': () => controller.getCrosswordState(),
        'highlightErrors': (duration?: number) => controller.highlightErrors(duration),
        'getRecording': (id: string) => controller.getRecording(id),
        'setRecording': (id: string, recording: CrosswordRecordingEvent[]) => {
          controller.setRecording(id, recording);
        },
        // TODO: This should be improved and perhaps be `fillClue` instead.
        // When filling, we need to get the direction right, and this information
        // is stored on the clues.
        'fillSquares': (squares: HTMLElement[], letters: string[], spacing?: number) => {
          controller.fillSquares(squares, letters, spacing ? spacing : 100);
        },
        'setProtectedElements': (elements: HTMLElement[]) => {
          elements.forEach((element: HTMLElement) => {
            controller.addProtectedElements(element);
          });
        },
      });
    }
  }
}

(<any>window).Wordcross = {};
(<any>window).Wordcross.App = App;
